// extracted by mini-css-extract-plugin
export default {"root":"HourInput_root__nBIQ4","hourInput":"HourInput_hourInput__OIioE","placeholder":"HourInput_placeholder__avT0s"};